import React, { Component } from "react";
import { Text } from "react-internationalization";
import { connect } from "react-redux";
import history from "../Utils/History";
import HomeIcon from "@material-ui/icons/Home";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import {
  login,
  agentLogin,
  guestLogout,
  LogoutToken,
  setStateParams,
  setLoginStateParams
} from "../Redux/Actions/webAppActions";
class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  zoom = (event, zoom) => {
    event.preventDefault();
    if (zoom === "large") {
      document.body.style.zoom = "125%";
    } else {
      document.body.style.zoom = "100%";
    }
  };
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  login = (event) => {
    event.preventDefault();
    this.props.setLoginStateParams("deeplink", false);
    this.props.setLoginStateParams("dpcountyName", "");
    this.props.setLoginStateParams("dpzipCode", "");
    this.props.setLoginStateParams("dpProductId", "");
    this.props.setLoginStateParams("dpStateCd", "");
    window.sessionStorage.clear();
    history.push("/e-Enroll/userLogin");
  };

  logout = async (event) => {
    event.preventDefault();
    this.props.LogoutToken();
    this.props.guestLogout();
    window.sessionStorage.clear();
    history.push("/e-Enroll/Login");
  };

  render() {
    return (
      <React.Fragment>
        <header class="header1 pt-1">
          <div>
            <div
              class="row flex-nowrap justify-content-between align-items-center header-mobile-padding"
            >
              <div class="col-6 pl-4 pt-1 text-left">
                <span class="wipro-logo wipro-logo-white"></span>
                <div class="navbar-left">
                  <a class="navbar-brand wipro-logo-print logo-print">
                    <img
                      src={require("../assests/images/wipro-logo.png")}
                      width="54"
                      height="42"
                      alt="Wipro Health Plan"
                    />
                  </a>
                </div>
                <a class="module-logo">
                  <span class="module-name">e-EnrollPlus</span>
                </a>
              </div>
              {!this.props.hide ? (
                <div class="col-6 pr-4 d-flex justify-content-end text-right">
                  <div>
                    {this.props.guestLoggedIn === true ? (
                      <button
                        class="navbar-link header-login noprint mr-2"
                        title="Log in"
                        data-module="-loginOverlay"
                        onClick={this.login}
                      >
                        {" "}
                        Wipro &nbsp;
                        <Text id="header.login" />
                        {/* <img
                          class="srch-login-img-tab"
                          src={require("../assests/images/login.png")}
                          width="25"
                          height="25"
                          alt="Wipro Login"
                        /> */}
                        <LockOutlinedIcon fontSize={"small"} />
                      </button>
                    ) : (
                      <div class="display-flex flex-row">
                        <div class="display-flex flex-column">
                          <p class="idName noprint logout-icon-container1">
                            {this.props.firstName && this.props.lastName
                              ? this.props.firstName + " " + this.props.lastName
                              : this.props.firstName}
                          </p>
                          {/* <p class="idName1 noprint">
                          Last Login: {(new Date().getMonth() + 1)
                            .toString()
                            .padStart(2, "0") +
                          "/" +
                          new Date().getDate().toString().padStart(2, "0") +
                          "/" +
                          new Date().getFullYear()
                        }
                          </p> */}
                        </div>
                        <div class="display-flex flex-row">
                          <span className="user-photo-icon"></span>
                          {/* <button
                          class="navbar-link header-login noprint"
                          title="Log out"
                          data-module="-loginOverlay"
                          onClick={this.logout}
                        >
                          Logout
                          {/* <img
                            class="srch-login-img-tab"
                            src={require("../assests/images/login.png")}
                            width="25"
                            height="25"
                            alt="Wipro Logout"
                          /> */}

                          {/* <LockOutlinedIcon fontSize={"small"}/> */}
                          {/* </button> */}
                          <div class="display-flex flex-column">
                            <button className="logout-btn display-flex noprint" onClick={this.logout}>
                              <i class="fa fa-sign-out logout-icon-container"></i>
                            </button>
                            <p className="idName1 noprint mr-3">Logout</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : this.props.home ? (
                <div class="home-btn col-4 d-flex justify-content-end text-right">
                  <HomeIcon
                    fontSize={"large"}
                    color={"primary"}
                    onClick={this.props.redirect}
                  />
                </div>
              ) : (
                <div class="col-4 d-flex justify-content-end text-right"></div>
              )}
            </div>
          </div>
        </header>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    lang: state.webApp.language,
    guestLoggedIn: state.login.guestLogin,
    agentID: state.login.agentId,
    email: state.login.emailAddress,
    firstName: state.login.firstName,
    lastName: state.login.lastName,
    agentLogin: state.login.agentLoggedIn,
  };
};
const mapDispatchToProps = {
  login,
  agentLogin,
  guestLogout,
  LogoutToken,
  setStateParams,
  setLoginStateParams,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
